<template>
  <div v-if="quote">
    <h1>{{ quote.id }}</h1>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "CreateFiles",
  data() {
    return {
      quote: null
    };
  },
  methods: {
    async fetchQuote() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/quotes/${this.$route.params.id}`
      );
      // console.log(response.data);
      this.quote = response.data;
    }
  },
  created() {
    this.fetchQuote();
  }
};
</script>
